var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('Header'),_c('Banner'),_c('div',{staticClass:"m-pc-page page-bottom"},[_c('Column'),_c('List')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }